import { render } from "./InternationalTradeRussiaEconRev.vue?vue&type=template&id=1f4e08f9&scoped=true"
import script from "./InternationalTradeRussiaEconRev.vue?vue&type=script&lang=js"
export * from "./InternationalTradeRussiaEconRev.vue?vue&type=script&lang=js"

import "./InternationalTradeRussiaEconRev.vue?vue&type=style&index=0&id=1f4e08f9&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4e08f9"]])

export default __exports__